module.exports = __webpack_public_path__ + "static/media/Circo2025_22.2c0bbab1.webp";